import script from "./ButtonClaim.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonClaim.vue?vue&type=script&setup=true&lang=js"

import "./ButtonClaim.vue?vue&type=style&index=0&id=60581a01&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60581a01"]])

export default __exports__